export default __webpack_public_path__ + "static/media/texmex003.dc00797d.jpg";